import { AirPriceFreezeStateWithoutValue } from "../types";

export const getContactInformation = (
  state: AirPriceFreezeStateWithoutValue
) => {
  return state.context.contactInformation;
};
